import { render, staticRenderFns } from "./ComplianceFlags.vue?vue&type=template&id=a8ef2d48&scoped=true&"
import script from "./ComplianceFlags.vue?vue&type=script&lang=js&"
export * from "./ComplianceFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ef2d48",
  null
  
)

export default component.exports